<template>
	<div class="grided-template">
		<menu-component></menu-component>
		<div id="batchOptimization-container">
			
			<default-header></default-header>
			<div id="panel-container">
				
				<!-- Primeiro Dropdown -->
				<collapsible-panel :panel="view.batchScenarioPanel"  :folded="view.batchScenarioPanel.folded"
				@collapsed="(v) => !(view.batchScenarioPanel.folded = v) && getBatchDataFromServer()"
				v-bind:class="{'collapsible-panel-fullscren': view.batchScenarioPanel.fullscreen}">
					
					<!-- Campo de select superior -->
					<div id="batchOptimization-header" class="batchOptimization-header">
						<div class="generic-select-wrapper">
							<v-select
								class="restrinctions-select-autocomplete"
								v-model="view.batchScenarioPanel.selectedBatch"
								:options="view.batchScenarioPanel.validityOptions" 
								:clearable="false"
								:getOptionLabel="this.getFormatted"
								@input="refreshBatch"
							><span slot="no-options">{{view.batchScenarioPanel.noOptionsText}}</span></v-select>
						</div>
					</div>
					
					<!-- grid tela 1-->
					<grid-component
						class="low-height-grid"
						style="margin-top: 5px;"
						@update:hasCheckedRows="(event) => { udpateCheckedRowsBatchItem(view.batchScenarioPanel, event); }"
						:grid="view.batchScenarioPanel.gridConfiguration"
					></grid-component>
					
					<!-- botões tela 1-->
					<div class="button-container">
						<div class="button-container-align-left">
							<button v-show="!view.batchScenarioPanel.hasCheckedRows"
									class="button batch-grid-button" 
									@click="showBatchModal(view)"> 
								<i class="fas fa-plus"></i> 
								{{$t('new_batch')}}
							</button>
							<button v-show="view.batchScenarioPanel.hasCheckedRows"
									class="button batch-grid-button" 
									@click="confirmOperation(view.batchScenarioPanel, 'GENERATION')"> 
								{{$t('generate_scenarios')}} 
							</button>
							<button v-show="view.batchScenarioPanel.hasCheckedRows"
									class="button batch-grid-button" 
									@click="confirmOperation(view.batchScenarioPanel, 'CALCULATE_ALERT')"> 
								{{$t('calculate_alerts')}} 
							</button>
						</div>
						<div class="button-container-align-right">
							<button v-show="view.batchScenarioPanel.hasCheckedRows"
									class="button batch-grid-button" 
									@click="confirmOperation(view.batchScenarioPanel, 'PUBLISH')"> 
								{{$t('publish_scenarios')}} 
							</button>
							<button class="button gray-button" @click="exportItGeracaoCard(view.batchScenarioPanel)">
								<i class="fas fa-file-excel"></i>
								<span> {{$t('export')}} </span> 
							</button>
							
							<button class="button gray-button" 
							@click="invertValue(view.batchScenarioPanel,'fullscreen')">
								<span v-show="!view.batchScenarioPanel.fullscreen">
									<i class="fas fa-expand-arrows-alt"></i>
								</span>
								<span v-show="view.batchScenarioPanel.fullscreen">
									<i class="fas fa-compress-arrows-alt"></i>
								</span>
							</button>
						</div>
					</div>
				</collapsible-panel>
				
				<!-- Segundo Dropdown -->
				<collapsible-panel name="GRID_LOGITGERACAOCARD" :panel="view.generationSummaryPanel" :folded="view.generationSummaryPanel.folded" 
					@collapsed="(v) => !(view.generationSummaryPanel.folded = v) && refreshSummary(null, true)"
					v-if="view.generationSummaryPanel.isVisible"
					v-bind:class="{'collapsible-panel-fullscren': view.generationSummaryPanel.fullscreen}">

					<!--Grid tela 2-->
					<grid-component
						class="low-height-grid"
						style="margin-top: 5px;"
						:grid="view.generationSummaryPanel.gridConfiguration"
					></grid-component>
					<!-- Footer grid 2 -->
					<div class="button-container">
						<div class="button-container-align-right">
							<button class="button gray-button" @click="exportLogItGeracaoCard(view.generationSummaryPanel)">
								<i class="fas fa-file-excel"></i>
								<span> {{$t('export')}} </span> 
							</button>
							
							<button class="button gray-button" 
							@click="invertValue(view.generationSummaryPanel,'fullscreen')">
								<span v-show="!view.generationSummaryPanel.fullscreen">
									<i class="fas fa-expand-arrows-alt"></i>
								</span>
								<span v-show="view.generationSummaryPanel.fullscreen">
									<i class="fas fa-compress-arrows-alt"></i>
								</span>
							</button>
						</div>
					</div>
				</collapsible-panel>
				
				<!-- Terceiro Dropdown -->
				<collapsible-panel name="GRID_LOGINCARDAMES" :panel="view.publicationSummaryPanel" :folded="view.publicationSummaryPanel.folded" 
					@collapsed="(v) => !(view.publicationSummaryPanel.folded = v) && refreshPublicSummary(null, true)"
					v-if="view.publicationSummaryPanel.isVisible"
					v-bind:class="{'collapsible-panel-fullscren': view.publicationSummaryPanel.fullscreen}">

					<!--Grid tela 3-->
					<grid-component
						class="low-height-grid"
						style="margin-top: 5px;"
						:grid="view.publicationSummaryPanel.gridConfiguration"
					></grid-component>
					<!-- Footer grid 3 -->
					<div class="button-container">
						<div class="button-container-align-right">
							<button class="button gray-button" @click="exportLogPublicationSummary(view.publicationSummaryPanel)">
								<i class="fas fa-file-excel"></i>
								<span> {{$t('export')}} </span> 
							</button>
							
							<button class="button gray-button" 
							@click="invertValue(view.publicationSummaryPanel,'fullscreen')">
								<span v-show="!view.publicationSummaryPanel.fullscreen">
									<i class="fas fa-expand-arrows-alt"></i>
								</span>
								<span v-show="view.publicationSummaryPanel.fullscreen">
									<i class="fas fa-compress-arrows-alt"></i>
								</span>
							</button>
						</div>
					</div>
				</collapsible-panel>
				
			</div>
		</div>
		
		<modal
            name="message" 
			:height="'auto'" 
			:clickToClose="false"
        >
            <message-pop-up 
                :modal="this.$modal"
                :title="view.popupMessage.title"
                :message="view.popupMessage.message"
                :nameModal="'message'"
            />
        </modal>
		<modal 
			name="new-batch-modal" 
			:height="'auto'" 
			:clickToClose="false"
		>
			<batch-form 
				:modal="$modal"
				:name="'Exportar Vigência'" 
				:modalStyle="view.newBatch._button"
				:validity="view.newBatch._validity"
				:showLoad="view.newBatch._showLoad"
				@saveNewBatch="saveNewBatch"
			/>
		</modal>
		<modal 
			name="messageError" 
			:height="'auto'" 
			:clickToClose="false"
		>
			<message-pop-up
				:modal="$modal"
				:title="view.newBatch._messageError.title"
				:message="view.newBatch._messageError.message"
				:nameModal="'messageError'"
			/>
		</modal>
		<grid-modal-simple
			:grid="view.gridModal"
			:visible="view.gridModal.isVisible"
			:dataSet="view.gridModal.dataSet"
			@chooseAction="chooseActionGridModal"
		>

		</grid-modal-simple>
	</div>
</template>

<script>
	import Menu from "@/components/src/MenuComponent";
	import DefaultHeader from "@/components/src/DefaultHeaderComponent";
	import CollapsiblePanel from "@/components/src/CollapsiblePanelComponent";
	import TabbedContainer from "@/components/src/TabbedContainerComponent";
	import Grid from "@/components/src/GridComponent";
	import vSelect from "vue-select";
	import Util from "@/application/libs/util"
	import permissionManager from "@/application/libs/permissionManager"
	import ExcelBuilder from  '@/application/libs/excelBuilder'
	import BatchForm from '@/components/src/BatchForm'
	import MessagePopUp from '@/components/src/MessagePopUp'
	import moment from 'moment';
	import { getSocketInstance } from '@/main.js';
	import eventModule from '@/application/libs/eventModule';
	// import {showConfirmationDialog} from '@/application/libs/ConfirmationDialog'
	import BatchOptimizationController from "../controllers/BatchOptimizationController";
	import GridModalSimple from '@/components/src/GridModalSimple';
	import { t } from 'i18next';
	
	export default {
		name: "BatchOptimization",
		props: {
			modal: {
            	type: Object
        	}	
		},
		components: {
			"menu-component": Menu,
			"default-header": DefaultHeader,
			"collapsible-panel": CollapsiblePanel,
			"tabbed-container": TabbedContainer,
			"grid-component": Grid,
			"v-select": vSelect,
			"batch-form": BatchForm,
			"message-pop-up": MessagePopUp,
			"grid-modal-simple": GridModalSimple
		},
		data() {
			return {
				view: {
					title: t('optimize_in_batch'),
					validityFormData:{
					}, 
					popupMessage: {
						title: '',
						message: ''
					},
					newBatch:{
						_showLoad: true,
						_messageError: {
							title: '',
							message: ''
						}
					},
					gridModal: {
						title: t('inconsistencies_alert_dishes_that_will_be_disregarded'),
						isVisible: false,
						columnDefs: [
							{
								name: "CODALERTA",
								label: t('code')
							},
							{
								name: "DSALERTA",
								label: t('name')
							},
							{
								name: "IDTIPOALERTA",
								label: t('description')
							}
						],
						columnDefsToExport: [
							{ header: t('code'), key: "CODALERTA" },
							{ header: t('name'), key: "DSALERTA" },
							{ header: t('description'), key: "IDTIPOALERTA"}
						],
						preRender( item ){
							const ALERT_TYPES = {
								PRATO_SEM_GRUPO: t('plate_has_no_linked_group'),
								PRATO_SEM_HISTORICO: t('dish_has_no_history_of_consumption'),
								PRATO_SEM_ATRATIVIDADE: t('dish_has_no_reported_attractiveness'),
								PRATO_SEM_CARACTERISTICA: t('dish_has_uninformed_characteristic'),
								PRATO_CUSTO_DESATU: t('dish_has_product_with_outdated_cost'),
								PRATO_CUSTO_ZERO: t('dish_has_product_with_zero_cost_or_outdated_for_more_than_3_months')
							};
							let newItem = {...item}; // non-recursive
							newItem.IDTIPOALERTA = ALERT_TYPES[item.IDTIPOALERTA] || item.IDTIPOALERTA;
							if(item.IDTIPOALERTA === 'PRATO_CUSTO_ZERO'){
								newItem.highLightRed = true;
								newItem.style = {
									font: {color: {argb:"FF0000"}}
								};
							}
							return newItem;
						},
						getCustomExcelHeader(){
							let otherInfo = this.grid.otherInfo;
							return [
								{label: t('date'), value: Util.getFilterInSession().DTMESCARD},
								{label: t('contract'), value: Util.getFilterInSession().TPCONTRATO},
								{label: t('unit_code'), value: otherInfo.CDFILIAL},
								{label: t('unit_name'), value: otherInfo.NOME_FILIAL},
								{label: t('service_code'), value: otherInfo.CDSERVFILI},
								{label: t('service_name'), value: otherInfo.NOME_SERVICO}
							]
						},
						dataSet: []
					},
					batchScenarioPanel: {
						title: t('batch_scenario_generation'),
						name: "batchScenarioPanel",
						gridConfiguration: BatchOptimizationController.batchScenarioGrid,
						validityOptions: [],
						selectedBatch: null,
						folded: false,
						noOptionsText: t('no_data_found'),
						hasCheckedRows: false,
						fullscreen: false,
						isAddingNewRow: false,
						isVisible: true,
						info:`.`,
					},
					generationSummaryPanel: {
						title: t('generation_summary'),
						name: "generationSummaryPanel",
						gridConfiguration: BatchOptimizationController.generationSummaryGrid,
						validityOptions: [],
						selectedBatch: null,
						folded: false,
						noOptionsText: t('no_data_found'),
						hasCheckedRows: false,
						fullscreen: false,
						isAddingNewRow: false,
						isVisible: true,
						info:`.`
					},
					publicationSummaryPanel: {
						title: t('publication_summary'),
						name: "publicationSummaryPanel",
						gridConfiguration: BatchOptimizationController.publicationSummaryGrid,
						validityOptions: [],
						selectedBatch: null,
						folded: false,
						noOptionsText: t('no_data_found'),
						hasCheckedRows: false,
						fullscreen: false,
						isAddingNewRow: false,
						isVisible: true,
						info:`.`
					},
					
				},
			};
		},
		mounted() {
			document.title = `${this.view.title} - Cardápio Inteligente`;
			this.getBatchDataFromServer();
			getSocketInstance().on('onSocketSceneryBatchMessage', this.onSocketSceneryBatchMessage);
			getSocketInstance().on('onSocketCalcAlertMessage', this.onSocketCalcAlertMessage);
			getSocketInstance().on('onUpdateScenary', this.onUpdateScenary);
		},
		created(){
			eventModule.$on('updateBoData', this.onUpdateBoData);
			eventModule.$on('showMessageModal', this.onShowMessageModal);
			eventModule.$on('showAlertGridModal', this.onShowAlertGridModal);

		},
		beforeDestroy(){
			eventModule.$off('updateBoData', this.onUpdateBoData);
			eventModule.$off('showMessageModal', this.onShowMessageModal);
			eventModule.$off('showAlertGridModal', this.onShowAlertGridModal);

			getSocketInstance().off('onSocketSceneryBatchMessage', this.onSocketSceneryBatchMessage);
			getSocketInstance().off('onSocketCalcAlertMessage', this.onSocketCalcAlertMessage);
			getSocketInstance().off('onUpdateScenary', this.onUpdateScenary);
		},
		methods: {
			chooseActionGridModal(){
				this.view.gridModal.isVisible = false;
				this.$forceUpdate();
			},
			onUpdateBoData(){
				this.getBatchDataFromServer();
			},
			onShowMessageModal({title, message}){
				this.showMessageModal(title, message);
			},
			onSocketCalcAlertMessage( response ){
				const {
					NRGERACAOCARD,
					ALL_NRITGERACAOCARD = [],
					STATUS = null,
					success
				} = response;
				const PANEL = this.view.batchScenarioPanel;
				const API = PANEL.gridConfiguration.advancedOptions.api;
				const { NRGERACAOCARD: NRGERACAOCARD_SELECTED } = PANEL.selectedBatch
				if( NRGERACAOCARD_SELECTED == NRGERACAOCARD ){
					if(STATUS == 'UPDATE_STATUS_INITIAL') {
						API.forEachNode( rowNode => {
							if(ALL_NRITGERACAOCARD.includes(rowNode.data.NRITGERACAOCARD)) {
								rowNode.data.IDSTATUSALERTA = 'ANDAMENTO';
							}
						});
						API.refreshCells({ columns: ['IDSTATUSALERTA'] });
					} else {
						if(success) {
							this.refreshBatch(PANEL.selectedBatch).then(_ => {
								Util.showSuccessNotification({
									title: t('calculation_of_alerts_performed_successfully'),
									text: ""
								});
							});
						} else {
							Util.showErrorNotificationFixed({
								title: t('error_calculating_alerts'),
								text: t('an_error_occurred_while_calculating_alerts')
							});
						}
					}
				} 
				
			},
			onSocketSceneryBatchMessage( response ){
				const {
					ROW_ID,
					NRGERACAOCARD,
					NRITGERACAOCARD,
					STATUS,
					NRCENARIOCARD,
					TIME,
					OPERATION,
					NRLOGINTCARDAMES,
					NRCENARIOVINCULO = 'EMPTY'
				} = response;
				const API = this.view.batchScenarioPanel.gridConfiguration.advancedOptions.api;
				let rowNode = API.getRowNode(ROW_ID);
				const { NRGERACAOCARD: NRGERACAOCARD_SELECTED } = this.view.batchScenarioPanel.selectedBatch;
				if(!ROW_ID || !rowNode) {
					if(NRCENARIOVINCULO !== 'EMPTY' && NRITGERACAOCARD && NRGERACAOCARD == NRGERACAOCARD_SELECTED) {
						let rowsToUpdate = [];
						let isMatchItem = ( itemToVerify, targetItem ) => itemToVerify == targetItem;
						if(Array.isArray(NRITGERACAOCARD)) {
							isMatchItem = ( itemToVerify, targetItem ) => targetItem.includes(itemToVerify);
						}
						API.forEachNode( rowNode => {
							let data = rowNode.data;
							if( isMatchItem(data.NRITGERACAOCARD, NRITGERACAOCARD) ) {
								data.NRCENARIOVINCULO = NRCENARIOVINCULO;
								rowsToUpdate.push( rowNode );
							}
						});
						API.redrawRows({rowNodes: rowsToUpdate});
					}
					return;
				};
				let numberRowsSelecteds = API.getSelectedNodes().length;
				let rowData = rowNode.data;
				let columns = ['IDSTATUSGERACAO', 'NRCENARIOCARD', 'NRCENARIOPUBLICAR'];
				if(OPERATION == "UPDATE_STATUS_INITIAL"){
					console.log(`Item: ${NRITGERACAOCARD} iniciado.`);
				} else if(TIME){
					console.log(`Item: ${NRITGERACAOCARD} gerado em ${TIME/1000} segundos.`);
				}
				if(rowData.NRITGERACAOCARD === NRITGERACAOCARD){
					rowData.IDSTATUSGERACAO = STATUS;
					if(OPERATION == 'GENERATE' && NRCENARIOCARD){
						rowData.NRCENARIOPUBLICAR = null;
						rowData.NRCENARIOCARD = NRCENARIOCARD;
					} else if(OPERATION == 'GENERATE' && NRCENARIOCARD === null){
						rowData.NRCENARIOCARD = null;
					}
					if(OPERATION == 'PUBLISH' && NRCENARIOCARD && STATUS == 'PUBLICADO_COM_ERRO') {
						rowData.NRLOGINTCARDAMES = NRLOGINTCARDAMES;
					}
					if( NRCENARIOVINCULO && NRCENARIOVINCULO !== 'EMPTY') {
						columns.push('NRCENARIOVINCULO');
						rowData.NRCENARIOVINCULO = NRCENARIOVINCULO
					}
				}
				if(OPERATION !== 'UPDATE_STATUS_INITIAL') {
					BatchOptimizationController.socketRefreshGenerationSummary(NRITGERACAOCARD, rowNode.selected, numberRowsSelecteds);
					BatchOptimizationController.socketRefreshPublicationSummary(NRLOGINTCARDAMES, rowNode.selected, numberRowsSelecteds);
				}
				
				this.refreshCells(this.view.batchScenarioPanel.gridConfiguration, columns);
			},
			onUpdateScenary( response ){
				const {
					NRGERACAOCARD: NRGERACAOCARD_SELECTED
				} = this.view.batchScenarioPanel.selectedBatch;
				const {
					NRGERACAOCARD,
					NRITGERACAOCARD,
					NRCENARIOPUBLICAR
				} = response;
				if( NRGERACAOCARD === NRGERACAOCARD_SELECTED) {
					const API = this.view.batchScenarioPanel.gridConfiguration.advancedOptions.api;
					API.forEachNode(function( rowNode){
						const { data: { NRITGERACAOCARD: NRITGERACAOCARD_ROW } } = rowNode;
						if( NRITGERACAOCARD === NRITGERACAOCARD_ROW ) {
							rowNode.data.NRCENARIOPUBLICAR = NRCENARIOPUBLICAR;
							API.refreshRows([rowNode]);
						}
					});
				}
			},
			emitMessage( msg ){
				let socket = getSocketInstance();
				if(socket.connected === false){
					return false;
				}
				socket.emit('message', msg || 'DefaultMessage');
				return true;
			},
			
			getFormatted: function(v){
				let mes = moment(v.DTMESGERACAOCARD, 'DD/MM/YYYY').format('MM/YYYY');
				let data = Util.getFilterInSession().DTMESCARD;
				return `Nº Lote: ${v.NRGERACAOCARD} 
		               - Operador: ${v.NMOPERADOR || ''}
		               - Data: ${data || ''} 		               
		               - Mês: ${mes || ''}`;
			},
			
			refreshBatch: async function(selectedBatch) {
				return BatchOptimizationController.refreshBatchOptimizationOptionsData(selectedBatch);
			},
			
			refreshSummary: function(selectedBatch, simpleReload = false) {
				return BatchOptimizationController.refreshGenerationSummary(selectedBatch, simpleReload);
			},
			refreshPublicSummary: function(selectedBatch, simpleReload = false) {
				return BatchOptimizationController.refreshPublicSummary(selectedBatch, simpleReload);
			},
			//função para validar o beforeDestroy, created e o mounted
			getBatchDataFromServer: async function( NRGERACAOCARD ){
				let {folded: foldedBatch, isVisible: isVisibleBatch} = this.view.batchScenarioPanel;
				let {folded: foldedSummary, isVisible: isVisibleSummary} = this.view.generationSummaryPanel;
				let {folded: foldedPublicationSummary, isVisible: isVisiblePublicSummary} = this.view.publicationSummaryPanel;
				let fetchBatch = !foldedBatch && isVisibleBatch && this.fetchBatchData();
				if(fetchBatch instanceof Promise){
					let responseBatch = await fetchBatch; //v-select batch
					if(Array.isArray(responseBatch) && responseBatch.length){
						let [ FIRST_BATCH ] = responseBatch;
						if( NRGERACAOCARD ){
							let filteredBatch = responseBatch.find( batch => batch.NRGERACAOCARD === NRGERACAOCARD);
							if( filteredBatch ) {
								FIRST_BATCH = filteredBatch;
							}
						}
						this.view.batchScenarioPanel.selectedBatch = FIRST_BATCH;
						let fetchBatchItem = await this.refreshBatch(FIRST_BATCH); // refresh grid batch
						if(Array.isArray(fetchBatchItem) && fetchBatchItem.length && !foldedSummary && isVisibleSummary) {
							let [ FIRST_BATCH_ITEM ] = fetchBatchItem;
							this.refreshSummary(FIRST_BATCH_ITEM); // refresh grid summary
						}
						if(Array.isArray(fetchBatchItem) && fetchBatchItem.length && !foldedPublicationSummary && isVisiblePublicSummary) {
							let [ FIRST_BATCH_ITEM ] = fetchBatchItem;
							this.refreshPublicSummary(FIRST_BATCH_ITEM); // refresh grid summary
						}
					} else {
						this.view.batchScenarioPanel.selectedBatch = null;
						this.refreshBatch();
						this.refreshSummary();
						this.refreshPublicSummary();
					}
				}
			},
			//função para trazer dados no select
			fetchBatchData: function() {
				return BatchOptimizationController.fetchBatchData(this.view.batchScenarioPanel);
			},
			showBatchModal: function() {
				this.$modal.show("new-batch-modal");
				this.$forceUpdate();
			},
			showMessageModal: function(title, message){
				this.view.popupMessage.title = title;
				this.view.popupMessage.message = message;
				this.$modal.show("message");
				this.$forceUpdate();	
			},
			saveNewBatch: function(view) {
				this.view.newBatch.showSpan = false; 
				const ALERT_COST = t('includes_alert_for_dish_that_has_product_with_zero_cost_or_outdated');
				const GENERATE_BATCH = t('confirm_batch_inclusion');
				const dispatchNewBatch = function(verifyAlert, verifyCost){
					this.view.newBatch._showLoad = false;
					this.$forceUpdate();
					BatchOptimizationController.newBatchProcedureCaller(view.batchData, this.$modal, this.view.newBatch, verifyAlert, verifyCost).then( function( NRGERACAOCARD ) {
						if( NRGERACAOCARD ){
							this.getBatchDataFromServer( NRGERACAOCARD );
						}
					}.bind(this));
				}.bind(this);
				Util.showConfirmationDialog(this.$modal, {
					onModalClose: function( confirmedGenerateBatch ){
						if(confirmedGenerateBatch) {
							if( view.batchData.checkedVerifyAlert ) {
								Util.showConfirmationDialog(this.$modal, {
									onModalClose: function(verifyCost){
										dispatchNewBatch(true, verifyCost);
									}.bind(this)
								}, ALERT_COST);
							} else {
								dispatchNewBatch(false, false);
							}
						}
					}.bind(this)
				}, GENERATE_BATCH);
			},
			udpateCheckedRowsBatchItem: function( panel ){
				let selectedRows = panel.gridConfiguration.advancedOptions.api.getSelectedRows(); 
				const hasCheckedRows = selectedRows.length > 0;
				panel.hasCheckedRows = hasCheckedRows;
			},
			confirmOperation(panel, OPERATION){
				const messages = {
					GENERATION: t('items_selected_with_generated_scenarios_will_be_overlaid'),
					PUBLISH: t('confirm_publication_of_selected_scenarios'),
					CALCULATE_ALERT: t('do_you_confirm_the_calculation_of_the_alerts_for_the_selected_item')
				};
				Util.showConfirmationDialog(this.$modal, function(){
					switch( OPERATION ){
						case "GENERATION":
							this.generateScenery( panel );
							break;
						case "PUBLISH":
							this.publishScenery( panel );
							break;
						case "CALCULATE_ALERT":
							Util.showConfirmationDialog(this.$modal, {
								onModalClose: function( costAlert ){
									this.calculateAlert( panel, costAlert );
								}.bind(this)
							}, t('include_alert_for_dish_that_has_product_with_zero_cost_or_outdated'));
							break;
					}
				}.bind(this), messages[OPERATION]);
			},
			validateWebSocketConnection(){
				if(getSocketInstance().connected == false){
					Util.showErrorNotificationFixed({
						title: t('webSocket_communication_error'),
						text: t('an_error_occurred_while_communicating_with_webSocket')
					});
				}
			},
			showErrorMessageBatchNode() {
				Util.showErrorNotificationFixed({
					title: t('connection_error'),
					text: t('an_error_occurred_while_connecting_to_the_server_for_batch_processing')
				});
			},
			refreshCells( grid, columns ){
				grid.advancedOptions.api.refreshCells({ columns });
			},
			redrawRows( grid, rowNodes ){
				grid.advancedOptions.api.redrawRows( { rowNodes } );
			},
			getSelectedNodes( grid ){
				return grid.advancedOptions.api.getSelectedNodes();
			},
			showInvalidCostParams(){
				this.showMessageModal(
					t('fill_in_the_required_fields'), 
					t('fill_in_the_type_of_cost_and_standard_cost_fields_correctly_to_generate_the_selected_scenarios')
				);
			},
			updateCostBeforeGenerateScenery( row ){
				let { data } = row;
				const { VRCUSTOPADRAO, VRCUSTOMIN, VRCUSTOMAX } = data;
				const isEmpty = value => !value;
				data.VRCUSTOPADRAO = BatchOptimizationController.valueToFloat(VRCUSTOPADRAO);
				const EMPTY_MIN_COST = isEmpty(BatchOptimizationController.valueToFloat(VRCUSTOMIN));
				const EMPTY_MAX_COST = isEmpty(BatchOptimizationController.valueToFloat(VRCUSTOMAX));
				data.VRCUSTOMIN = EMPTY_MIN_COST ? VRCUSTOPADRAO : VRCUSTOMIN;
				data.VRCUSTOMAX = EMPTY_MAX_COST ? VRCUSTOPADRAO : VRCUSTOMAX;
				
				if( EMPTY_MIN_COST || EMPTY_MAX_COST ){

					const { NRITGERACAOCARD, VRCUSTOPADRAO, VRCUSTOMIN, VRCUSTOMAX	} = data;
					const COST_PARAMS = { NRITGERACAOCARD, VRCUSTOPADRAO, VRCUSTOMIN, VRCUSTOMAX };
					return BatchOptimizationController.saveCost(COST_PARAMS).then( _ => row );

				}
				return Promise.resolve(row);
			},
			generateSceneryFromRowNode( row, NRGERACAOCARD, CHILDREN, grid ){
				let {
					data: { NRITGERACAOCARD, IDSTATUSGERACAO },
					id: ROW_ID
				} = row;

				return this.updateCostBeforeGenerateScenery(row).then(function(rowNode) {
					if(rowNode) {
						this.redrawRows(grid, [rowNode]);
						return BatchOptimizationController.generateScenery({
							NRGERACAOCARD,
							NRITGERACAOCARD,
							ROW_ID,
							CHILDREN
						});
					}
				}.bind(this));
			},
			updateStatusItems( selectedNodes ){
				return BatchOptimizationController.updateStatusItems(
					selectedNodes.map(
						( {data: { NRITGERACAOCARD }} ) => NRITGERACAOCARD
					),
					'ANDAMENTO'
				);
			},
			generateScenery: async function( panel ){
				let selectedNodes = panel.gridConfiguration.advancedOptions.api.getSelectedNodes();
				
				const { NRGERACAOCARD } = panel.selectedBatch;
				const { PARENT, CHILDREN } = await BatchOptimizationController.getLinkedService( NRGERACAOCARD );
				let requiredParamsFilled = true;
				let allChildren = {};
				selectedNodes.forEach( row => {
					let { data: { NRITGERACAOCARD, CDFILIAL, CDSERVFILI, CDTIPOCUSTO, VRCUSTOPADRAO }, id: ROW_ID } = row;
					const FILISERV = `FILISERV_${CDFILIAL}${CDSERVFILI}`;
					if(PARENT.has(FILISERV)){
						let valueToSet = PARENT.get(FILISERV);
						if(valueToSet && valueToSet.children){
							valueToSet.children = valueToSet.children.map( NRITGERACAOCARD_CHILD => {
								let child = {
									NRITGERACAOCARD: NRITGERACAOCARD_CHILD,
									NRGERACAOCARD,
									ROW_ID: null
								};
								if(allChildren[NRITGERACAOCARD_CHILD]){
									child.ROW_ID = allChildren[NRITGERACAOCARD_CHILD].ROW_ID;
								}
								allChildren[NRITGERACAOCARD_CHILD] = child;
								return child;
							});
						}
						PARENT.set(NRITGERACAOCARD, valueToSet);
						PARENT.delete(FILISERV);
					} else if( CHILDREN[NRITGERACAOCARD] ){
						if(!allChildren[NRITGERACAOCARD]) {
							allChildren[NRITGERACAOCARD] = {};
						}
						allChildren[NRITGERACAOCARD].ROW_ID = ROW_ID; 
						console.log(allChildren);
					}
					if(!CDTIPOCUSTO || !Number(VRCUSTOPADRAO)){
						requiredParamsFilled = false;
					}
				});
				
				if(!requiredParamsFilled){
					this.showInvalidCostParams();
					return;
				}
				await this.updateStatusItems(selectedNodes);
				const ALL_PROMISE_GENERATION = [];
				selectedNodes.forEach( row => {
					let child = CHILDREN[row.data.NRITGERACAOCARD] || null;
					let currentChildren = (PARENT.get(row.data.NRITGERACAOCARD) || {}).children;
					let isSelectedParent = false;
					if( child ) {
						isSelectedParent = !PARENT.has(`FILISERV_${child.CDFILIALORIG}${child.CDSERVORIG}`);
					}
					currentChildren = currentChildren || [];
					if( !child || (!isSelectedParent && row.data.NRCENARIOVINCULO)){ // generate non-dependents items
						ALL_PROMISE_GENERATION.push(
							this.generateSceneryFromRowNode(
								row, 
								NRGERACAOCARD, 
								currentChildren, 
								panel.gridConfiguration
							)
						);
					}
				});
				Promise.all(ALL_PROMISE_GENERATION).catch( error => {
					console.log(error);
					this.showErrorMessageBatchNode();
				});
				this.validateWebSocketConnection();
				this.refreshCells(panel.gridConfiguration, ['IDSTATUSGERACAO']);
			},
			publishScenery: async function( panel ){
				let selectedNodes = panel.gridConfiguration.advancedOptions.api.getSelectedNodes();
				const { NRGERACAOCARD } = panel.selectedBatch;
				const permitedStatus = ["FINALIZADO_COM_ERRO", "FINALIZADO_SEM_ERRO", "PUBLICADO_COM_ERRO", "PUBLICADO_SEM_ERRO"];
				let isValid = selectedNodes.every( row => {
					let { NRCENARIOCARD, IDSTATUSGERACAO } = row.data;
					return NRCENARIOCARD && permitedStatus.includes(IDSTATUSGERACAO);
				});
				if(!isValid){
					this.showMessageModal(t('publication_not_allowed'), t('menus_without_generated_scenery_cannot_be_published'));
					return;
				}
				await this.updateStatusItems(selectedNodes);
				selectedNodes.forEach( row => {
					let data = row.data;
					BatchOptimizationController.publishScenery({
						NRGERACAOCARD,
						NRITGERACAOCARD: data.NRITGERACAOCARD,
						NRCENARIOCARD: data.NRCENARIOCARD,
						NRCENARIOPUBLICAR: data.NRCENARIOPUBLICAR,
						ROW_ID: row.id
					});
					this.emitMessage({NRITGERACAOCARD: data.NRITGERACAOCARD, ROW_ID: row.id});
				});
				panel.gridConfiguration.advancedOptions.api.refreshCells({
					columns: ['IDSTATUSGERACAO']
				});
			},
			calculateAlert( panel, costAlert ){
				const VERIFY_COST = costAlert ? 'S' : 'N';
				const selectedNodes = panel.gridConfiguration.advancedOptions.api.getSelectedNodes();
				const ALL_NRITGERACAOCARD = selectedNodes.map( ({data: { NRITGERACAOCARD}}) => NRITGERACAOCARD);
				const { NRGERACAOCARD } = panel.selectedBatch;
				const PARAMS = {
					ALL_NRITGERACAOCARD,
					NRGERACAOCARD,
					VERIFY_COST
				};
				BatchOptimizationController.calculateAlert(PARAMS);
			},
			invertValue: function(object, key){
				object[key] = !object[key];
			},
			exportItGeracaoCard( panel ){
				const NAME = `- Lote ${panel.selectedBatch.NRGERACAOCARD}`;
				const TITLE = `${panel.title} ${NAME}`;
				this.exportToExcel(panel, TITLE);
			},
			exportLogItGeracaoCard( panel ){
				this.exportToExcel(panel, panel.title, panel.gridConfiguration.dataSourceFilter.NRITGERACAOCARD);
			},
			exportLogPublicationSummary( panel ){
				this.exportToExcel(panel, panel.title);
			},
			
			exportToExcel: async function(panel, title, NRITGERACAOCARD = null){
				let header = Util.getExcelHeaderFromFilter();
				if( NRITGERACAOCARD ){
					const data = await BatchOptimizationController.getCabecalhoExportLog(NRITGERACAOCARD);
					const TPCONTRATO = {
						PLANEJADO: t('planned'),
						CONTRATO: t('contract')
					};
					header = [
						{label: t('scenario_number'), value: data.NRCENARIOCARD},
						{label: t('date'), value: data.DTMESGERACAOCARD},
						{label: t('contract'), value: TPCONTRATO[data.IDTIPORESTRICAO]},
						{label: t('unit_code'), value: data.CDFILIAL},
						{label: t('unit_name'), value: data.NMFILIAL},
						{label: t('service_code'), value: data.CDSERVFILI},
						{label: t('service_name'), value: data.NMSERVICO}
					];
				}
				let grid = panel.gridConfiguration;
				const { formatValuesExport = null } = grid;
				ExcelBuilder.fromJson(
					Util.getVisibleDataFromGrid(panel.gridConfiguration, formatValuesExport),
					Util.getGridColDefsToColDetails(panel.gridConfiguration.columnDefs),
					title,
					header,
				);
			},
			onShowAlertGridModal( {dataSet, otherInfo = {}} ){
				this.view.gridModal.otherInfo = otherInfo;
				this.view.gridModal.dataSet = dataSet;
				this.view.gridModal.isVisible = true;
			}
		}
	};
</script>
<style lang="less">

	.alert-cell {
		text-align: center; 
        display: flex;
        flex-direction: row;
        justify-content: space-around;
		.search-button {
			display: flex;
			align-items: center;
			border: solid 1px #80808045;
			border-radius: 20%;
			padding: 0px 10px;
			max-height: 25px;
		}
		.search-button.alert-enabled {
			cursor: pointer;
			background-color: #dedede;
			svg {
				color: #383838;
			}
		}
		.search-button.alert-disabled {
			background-color: #e2e2e27a;
			cursor: not-allowed;
			svg {
				color: #38383873;
			}
		}
	}

</style>
<style lang="less" scoped>
	.select-container {
		display: grid;
		grid-template-columns: 80% 20%;

		.input-container {
			margin: auto;

			input, span {
				vertical-align: middle;
				display: inline-block;
			}
		}
	}

	.allCheck {
        position: relative;
		cursor: pointer;
		height: 20px;
    	width: 20px;
	}
	
    .allCheck:before {
        content: "";
		display: block;
		position: absolute;
		width: 20px;
		height: 20px;
		top: 0;
		left: 0;
		background-color: white;
		border: 2px solid #dc143d;
		border-radius: 5px;
	}

	.allCheck:checked:before {
        content: "";
		display: block;
		position: absolute;
		margin: auto;
		width: 20px;
		height: 20px;
		top: 0;
		left: 0;
		background-color: #dc143d;
		border: 2px solid #dc143d;
		border-radius: 5px;
	}

    .allCheck:checked:after {
    	content: "";
		display: block;
		width: 5px;
		height: 10px;
		border: solid white;
		border-width: 0 2px 2px 0;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		position: absolute;
		top: 4px;
		left: 9px;
	}

	.button{
		min-width: 100px;
		padding: 6px 15px;
		margin: auto 3px;

		&.ghost{
			background-color: white;
			box-shadow: none;
			color: #dc143d;
			border: 1px solid #dc143d;
			padding: 5px 14px;

			&:hover{
				color: #212146;
				border: 1px solid #212146;
			}
		}
	}
	.mode-switch{
        margin-top: 10px;
        font-size: .9rem;
        border-radius: 5px;
        width: fit-content;
        color: #DC143D;
        border: 1px solid #DC143D;
        cursor: pointer;
        user-select: none;
        width: 100%;
        display: flex;

        .mode-switch-option{
            flex: 1;
            text-align: center;
            border-radius: 5px;
            padding: 7px;
            transition: .3s background-color;
            &:hover{
                background-color: #fcdee4;
            }

            &.active{
                background-color: #DC143D;
                color: white;
            }
        }
	}
	
	.select-350{
		.v-select ul{
			width: 350px;
			z-index: 6;
		}
	}

	.generic-select-wrapper{
		
		.v-select{
			width: 580px;
			font-size: .6rem;

			&.vs--open{
				.vs__selected-options{
					overflow: hidden;
				}	
			}

			.vs__selected-options{
				min-height: 24px;
				min-width: 0;
				input{
					position: absolute;
					height: 100%;
					width: 100%;
				}
				.vs__selected{
					overflow: hidden;
    				text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
		}
	}

	.batchOptimization-header{
		display: flex;
		align-items: center;
	}

	.batch-grid-button{
    	font-size: 0.9rem;
    	padding: 6px 13px;
		margin: 5px 0px 5px 5px;
	}

	.gray-button{
		.batch-grid-button;
		box-shadow: none;
		background-color: #dedede;
		color: #383838;
		&:hover{
			background-color: gray;
			color:white;
		}
	}

	.button-container{
		margin-top: 3px;
	}

	.button-container-align-left, .button-container-align-right{
		display: inline-block;
    	flex: 1;
	}
	
	.button-container{
		display: flex;
    	justify-content: space-between;
	}

	.button-container-align-right{
		text-align: right;
	}

	.new-batch-form-root{
		width: calc(100% - 30px);
		margin: 25px;
		margin-bottom: 30px;

		.autocomplete-field{
			.restrinctions-select-autocomplete{

				.vs__selected-options{
					height: 26px;
				}

				.vs__search{
					position: absolute; // prevent parent from computing auto height
					padding: 1px;
					border: none;
				}
			}
		}


		.title{
			margin-bottom: 5px;
			margin-left: 10px;
		}

		.date-fields-container{
			.field{
				width: 44%;
				display: inline-block;
			}
		}

		.export-container {
			display: inline-block;
			margin: 10px;
			text-align: left;
			font-size: .9rem;
			width: calc(100% - 45px);
		}

		.field{
			display: inline-block;
			margin: 10px;
			text-align: left;
			font-size: .9rem;
			width: calc(100% - 45px);

			&.text-field{
				input{ 
					padding: 6px 0px 7px 8px;
				}
			}

			input{
				padding: 5px;
				border: 1px solid #BDBDBD;
				box-sizing: border-box;
				border-radius: 4px;
				width: 100%;

				&.input-label{
					border: none;
					border-bottom: 1px solid #BDBDBD;
					border-radius: 0;
				}
			}

		}

		.save-new-batch-button{
			.batch-grid-button;
			margin-left: 10px;
		}
		
		.cancel-new-batch-button{
			.batch-grid-button;
			margin-left: 10px;
		}

		&.dialog-box{
			width: auto;
			margin: 0 auto;
			padding: 5px;

			.title{
				text-align: center;
				margin-left: 0;
				margin-top: 10px;
				font-weight: normal;
    			font-size: 1rem;
			}

			.service-list{
				list-style: none;
			}

		}

	}

	#batchOptimization-container{
		#header-component{
			position: fixed;
			z-index: 7;
			width: calc(100% - 100px);
		}
		#panel-container{
			margin-top: 55px;
		}

		.low-height-grid{
			height: 200px;
		}

		#collapsible-panel.collapsible-panel-fullscren{
			position: fixed;
			top: 48px;
			left: 100px;
			z-index: 2;
			background-color: white;
			height: calc(100vh - 69px);
			width: calc(100vw - 125px);
			padding: 20px 15px;
			border-radius: 0;
			padding-top: 0px;
			margin:0;

			#panel-header{
				.up-arrow, .down-arrow{
					display: none;
				}
			}

			.button-container{
				margin-top: 0;
			}

			#panel-content{
				.ag-grid-instance{
					height: calc(100vh - 170px);
				}
			}
		}
		#collapsible-panel.collapsible-panel-fullscren[name="GRID_LOGITGERACAOCARD"]{
			#panel-content{
				.ag-grid-instance{
					height: calc(100vh - 145px);
				}
			}
		}
		#collapsible-panel.collapsible-panel-fullscren[name="GRID_LOGINCARDAMES"]{
			#panel-content{
				.ag-grid-instance{
					height: calc(100vh - 145px);
				}
			}
		}
	}

	.v--modal-overlay{
		z-index: 10;
	}

	.v--modal-box {
		overflow: inherit!important;
		padding: 30px 0;
	}
	.fa-exclamation {
		color: red;
	}
	.fa-check {
		color: green;
	}
	.fa-cog {
		color: gray;
	}
	
</style>
